import Vue from 'vue'
import Router from 'vue-router'
import index from '../page/index/index.vue'
import contact from '../page/home_v2.0/contact.vue'

// const thailand = r => require.ensure([], () => r(require('../page/home_v2.0/country/thailand.vue')), 'thailand')
const chile = r => require.ensure([], () => r(require('../page/home_v2.0/country/chile.vue')), 'chile')
// const bangladesh = r => require.ensure([], () => r(require('../page/home_v2.0/country/bangladesh.vue')), 'bangladesh')
// const iraq = r => require.ensure([], () => r(require('../page/home_v2.0/country/iraq.vue')), 'iraq')
// const turkey = r => require.ensure([], () => r(require('../page/home_v2.0/country/turkey.vue')), 'turkey')
// const egypt = r => require.ensure([], () => r(require('../page/home_v2.0/country/egypt.vue')), 'egypt')
// const argentina = r => require.ensure([], () => r(require('../page/home_v2.0/country/argentina.vue')), 'argentina')
// const philipines = r => require.ensure([], () => r(require('../page/home_v2.0/country/philipines.vue')), 'philipines')
// const india = r => require.ensure([], () => r(require('../page/home_v2.0/country/india.vue')), 'india')
// const vietnam = r => require.ensure([], () => r(require('../page/home_v2.0/country/vietnam.vue')), 'vietnam')
// const Indonesia = r => require.ensure([], () => r(require('../page/home_v2.0/country/Indonesia.vue')), 'Indonesia')
// const pakistan = r => require.ensure([], () => r(require('../page/home_v2.0/country/pakistan.vue')), 'pakistan')
// const colombia = r => require.ensure([], () => r(require('../page/home_v2.0/country/colombia.vue')), 'colombia')
// const brazil = r => require.ensure([], () => r(require('../page/home_v2.0/country/brazil.vue')), 'brazil')
// const kenya = r => require.ensure([], () => r(require('../page/home_v2.0/country/kenya.vue')), 'kenya')
// const nigeria = r => require.ensure([], () => r(require('../page/home_v2.0/country/nigeria.vue')), 'nigeria')
const mexico = r => require.ensure([], () => r(require('../page/home_v2.0/country/mexico.vue')), 'mexico')
const privacyPolicy = r => require.ensure([], () => r(require('../page/home_v2.0/privacyPolicy.vue')), 'privacyPolicy')
const userAgreement = r => require.ensure([], () => r(require('../page/home_v2.0/userAgreement.vue')), 'userAgreement')
const SpecificTermConditions = r => require.ensure([], () => r(require('../page/home_v2.0/SpecificTermConditions.vue')), 'SpecificTermConditions')
const home = r => require.ensure([], () => r(require('../page/home_v3.0/home.vue')), 'home')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/mexico',
      name: 'mexico',
      component: mexico
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: userAgreement
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: privacyPolicy
    },
    {
      path: '/SpecificTermConditions',
      name: 'SpecificTermConditions',
      component: SpecificTermConditions
    },
    // {
    //   path: '/nigeria',
    //   name: 'nigeria',
    //   component: nigeria
    // },
    // {
    //   path: '/kenya',
    //   name: 'kenya',
    //   component: kenya
    // },
    // {
    //   path: '/brazil',
    //   name: 'brazil',
    //   component: brazil
    // },
    // {
    //   path: '/colombia',
    //   name: 'colombia',
    //   component: colombia
    // },
    // {
    //   path: '/pakistan',
    //   name: 'pakistan',
    //   component: pakistan
    // },
    // {
    //   path: '/Indonesia',
    //   name: 'Indonesia',
    //   component: Indonesia
    // },
    // {
    //   path: '/vietnam',
    //   name: 'vietnam',
    //   component: vietnam
    // },
    // {
    //   path: '/india',
    //   name: 'india',
    //   component: india
    // },
    // {
    //   path: '/philipines',
    //   name: 'philipines',
    //   component: philipines
    // },
    // {
    //   path: '/argentina',
    //   name: 'argentina',
    //   component: argentina
    // },
    // {
    //   path: '/egypt',
    //   name: 'egypt',
    //   component: egypt
    // },
    // {
    //   path: '/iraq',
    //   name: 'iraq',
    //   component: iraq
    // },
    // {
    //   path: '/turkey',
    //   name: 'turkey',
    //   component: turkey
    // },
    // {
    //   path: '/bangladesh',
    //   name: 'bangladesh',
    //   component: bangladesh
    // },
    // {
    //   path: '/thailand',
    //   name: 'thailand',
    //   component: thailand
    // },
    {
      path: '/chile',
      name: 'chile',
      component: chile
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js